<template>
	<div v-loading="loading" element-loading-text="下载中,请稍后" element-loading-spinner="el-icon-loading">
		<el-row>
			<!-- <el-card> -->
			<el-row :gutter="20">
				<el-col :xs="24" :sm="8" :md="8">
					<el-input v-model="keywords" size="mini" placeholder="输入关键字搜索" maxlength="30" clearable style="margin:5px" @change="Search()">
						<el-button slot="append" icon="el-icon-search" @click="Search()"></el-button>
					</el-input>
				</el-col>
			</el-row>
			<el-table :data="tableData" style="width: 100%; " stripe :default-sort="{ prop: 'date', order: 'descending' }">
				<el-table-column type="expand">
					<template slot-scope="props">
						<el-form label-position="left" class="demo-table-expand">
							<el-row>
								<el-col :xs="24" :sm="12">
									<el-form-item label="姓名">
										<span>{{ props.row.marketer_name }}</span>
									</el-form-item>
									<el-form-item label="部门">
										<span>{{ props.row.marketer_dept }}</span>
									</el-form-item>
									<el-form-item label="职务">
										<span>{{ props.row.marketer_duty }}</span>
									</el-form-item>
									<el-form-item label="负责地区">
										<span>{{ props.row.marketer_incharge_area }}</span>
									</el-form-item>
								</el-col>
								<el-col :xs="24" :sm="12">
									<el-form-item label="工作内容">
										<span>{{ props.row.marketer_incharge_affair }}</span>
									</el-form-item>
									<el-form-item label="工作经历">
										<span>{{ props.row.marketer_work_exp }}</span>
									</el-form-item>
									<el-form-item label="备注">
										<span>{{ props.row.marketer_remark }}</span>
									</el-form-item>
<!-- 									<el-form-item label="上报人">
										<span>{{ props.row.marketer_user__person_name }}</span>
									</el-form-item> -->
								</el-col>
							</el-row>
						</el-form>
					</template>
				</el-table-column>
				<el-table-column label="公司" prop="marketer_ga__ga_name" sortable show-overflow-tooltip />
				<el-table-column label="姓名" prop="marketer_name" sortable show-overflow-tooltip />
				<el-table-column label="部门" prop="marketer_dept" sortable />
				<el-table-column label="职务" prop="marketer_duty" sortable />
				<el-table-column label="负责地区" prop="marketer_incharge_area" sortable show-overflow-tooltip />
				<!-- <el-table-column label="上报人" prop="marketer_user__person_name" show-overflow-tooltip /> -->
			</el-table>
			<!-- 分页 -->
			<el-row class="paginator hidden-sm-and-down">
				<el-pagination
					background
					:current-page.sync="currentPage"
					layout="total, sizes, prev, pager, next"
					:total="totalItems"
					:page-sizes="[10, 20, 50, 100]"
					:page-size="pageSize"
					@current-change="handleCurrentChange"
					@size-change="handleSizeChange"
				/>
			</el-row>

			<el-row class="paginator hidden-sm-and-up">
				<el-pagination
					background
					:current-page.sync="currentPage"
					layout="prev, pager, next"
					:total="totalItems"
					:page-size="pageSize"
					@current-change="handleCurrentChange"
					@size-change="handleSizeChange"
					prev-text="上一页"
					next-text="下一页"
					:pager-count="5"
				/>
			</el-row>
			<!-- </el-card> -->
		</el-row>


	</div>
</template>

<script>
export default {
	inject: ['reload', 'logout'],
	data() {
		return {
			tableData: [],
			keywords: '',
			ifFullScreen: false,
			formLabelWidth: '150px',
			totalItems: 100,
			currentPage: 1,
			pageSize: 20,
			deleteItemPk: '',
			loading: false
		};
	},
	methods: {
		//通用函数-获取数据
		getData(keywords, currentPage, pageSize) {
			var that = this;
			that.loading = true;
			this.$axios
				.get('/apim/get/querymarketer/', {
					params: {
						keywords: keywords,
						currentpage: currentPage,
						pagesize: pageSize
					}
				})
				.then(function(response) {
					if (response.data.code == '401') {
						that.logout();
					} else {
						that.tableData = response.data.data;
						that.totalItems = response.data.totalItemNum;
						that.loading = false;
					}
				})
				.catch(function(error) {
					console.log(error);
					that.loading = false;
				});
		},
		//通用功能 - 关键字搜索
		Search() {
			var that = this;
			this.getData(that.keywords, that.currentPage, that.pageSize);
		},

		//分页跳转
		handleCurrentChange(val) {
			var that = this;
			this.currentPage = val;
			this.getData(that.keywords, that.currentPage, that.pageSize);
		},
		//每页显示条数更改
		handleSizeChange(val) {
			var that = this;
			this.pageSize = val;
			this.getData(that.keywords, that.currentPage, that.pageSize);
		}

	},
	mounted() {
		var that = this;
		this.getData('', that.currentPage, that.pageSize);
		that.ifFullScreen = document.body.clientWidth > 720 ? false : true;
	}
};
</script>

<style></style>
